import {CouponManagingPageSet} from './interfaces'

export const RejectValue = {
    // 매 결제시 쿠폰사용 여부 조회 중 오류 발생
    FETCH_USE_ALL_COUPON_REJECTED_DEFAULT: 'FETCH_USE_ALL_COUPON_REJECTED_DEFAULT',
    // 매 결제시 쿠폰사용 설정 변경 중 오류 발생
    CHANGE_USE_ALL_COUPON_REJECTED_DEFAULT: 'CHANGE_USE_ALL_COUPON_REJECTED_DEFAULT',
}

export const NlogAreaCode: Record<CouponManagingPageSet, string> = {
    SHOPPING_SUBSCRIPTION: 'regcou',
}
